var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4688 28.6368L36.2192 27.096V31.3152L35.2256 31.9488C35.0528 32.04 33.7856 32.688 31.8128 32.9712V40.968C31.8128 43.1952 30.008 45 27.7808 45C25.5536 45 23.7488 43.1952 23.7488 40.968C23.7488 38.7408 25.5536 36.936 27.7808 36.936C27.8768 36.936 27.968 36.936 28.064 36.9456V29.352H29.9408C31.9664 29.352 33.3632 28.6848 33.4736 28.632L33.4688 28.6368ZM43.4288 50.2512H16.6256C15.5936 50.2512 14.7488 49.4112 14.7488 48.3744V11.6256C14.7488 10.5936 15.5888 9.7488 16.6256 9.7488H33.0224V16.416C33.0224 19.5168 35.5472 22.0416 38.648 22.0416H45.3056V48.3744C45.3056 49.4064 44.4656 50.2512 43.4288 50.2512ZM36.7712 12.3648L42.6656 18.2928H38.6432C37.6112 18.2928 36.7664 17.4528 36.7664 16.416V12.3648H36.7712ZM35.7296 6H16.6256C13.5248 6 11 8.52482 11 11.6256V48.3744C11 51.4752 13.5248 54 16.6256 54H43.4288C46.5296 54 49.0544 51.4752 49.0544 48.3744V19.392L35.7296 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverSong);
export default __webpack_public_path__ + "static/media/coverSong.01e57074.svg";
export { ForwardRef as ReactComponent };